module.exports = __webpack_public_path__ + "a96eacf834096e2ffe6b44eff64d0b73.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-regular-webfont.woff2
 ** module id = ./src/styles/fonts/lato/lato-regular-webfont.woff2
 ** module chunks = 0
 **/